import { useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useJobCatalogTreeVisibility } from 'modules/job_catalog/hooks/useJobCatalogTreeVisibility'
import {
  NODE_TYPES,
  getNavigationForTypeFromFunction,
  getNodeTypeFromParams,
  isNodeType,
  nodeTypeChildren,
} from 'modules/job_catalog/lib/nodesUtils'

interface NodeTab {
  id: string
  label: string
}

export const useNodeTabs = () => {
  const { navigation } = useNavigation()
  const { rootId, familyId, functionId, roleId, levelId } = useParams()

  const { canSeeCompetencies, canSeeItManagement } = useJobCatalogTreeVisibility()

  const nodeType = getNodeTypeFromParams({ familyId, functionId, roleId, levelId })
  const nodeLabel = isNodeType(nodeType) ? nodeTypeChildren(nodeType) : nodeType

  const params: {
    rootId: string
    familyId: string
    functionId?: string
    roleId?: string
    levelId?: string
  } = {
    rootId: rootId || '',
    familyId: familyId || '',
    ...(functionId && { functionId }),
    ...(roleId && { roleId }),
    ...(levelId && { levelId }),
  }

  const navParams = {
    rootId: params.rootId,
    familyId: params.familyId,
    functionId: params.functionId || '',
    roleId: params.roleId || '',
    levelId: params.levelId || '',
  }

  const nav = getNavigationForTypeFromFunction(navigation, nodeType)

  const tabs: NodeTab[] = []

  const isNodeLevel = nodeType === NODE_TYPES.LEVEL

  if (!isNodeLevel) {
    tabs.push({
      id: nav.overview.fullPath(navParams),
      label: nodeLabel,
    })
  }

  if (canSeeCompetencies) {
    tabs.push({
      id: nav.competencies.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.competency.multiple'),
    })
  }

  tabs.push(
    {
      id: nav.workingConditions.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.working_conditions.multiple'),
    },
    {
      id: nav.salaries.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.salaries.multiple'),
    },
    {
      id: nav.people.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.people.one'),
    }
  )

  if (canSeeItManagement) {
    tabs.push({
      id: nav.itManagement.fullPath(navParams),
      label: i18n.t('job_catalog.nodes.it_management.one'),
    })
  }

  return tabs
}
